module.exports = __webpack_public_path__ + "img/mydocs.1f87fd29.svg";